import React, { useEffect, useRef, useState } from "react";
import { Circle, Eye, EyeOff } from "lucide-react";
import { formatDateInUS, showErrorToast, showSuccessToast } from "../../utils/utils";
import { getData, postData } from "../../services/Axios/Axios";
import { ApiUrl } from "../../config/apiConfig";
import { sendAccountStatusChangeMail, sendLoginCredentialsMail } from "../../functions/accountFunctions";
import TurnstileWidget, { TurnstileWidgetHandle } from "../TurnstileWidget";


type Customer = {
    selectedCustomer: any;
    setSelectedCustomer: any;
    hideLabels?: boolean;

};


interface TutorialLog {
    title: string;
    progress: number;
    language: string;
    videoUrl: string;
}

type VideoItem = {
    title: string;
    progress?: {
        progressPercent: number;
    };
    [key: string]: any;
};

export default function AccessTab({ selectedCustomer, setSelectedCustomer, hideLabels = false }: Customer) {
    const [showPassword, setShowPassword] = useState(false);
    const [isLoading, setLoading] = useState(false);
    const [tutorialLogs, setTutorialLogs] = useState<TutorialLog[]>([])
    const [emailLoading, setEmailLoading] = useState(false);
    // /v2/email/send-email requires a Turnstile token (action "send_email")
    // for every caller, including authenticated admins.
    const [mailCaptchaToken, setMailCaptchaToken] = useState("");
    const mailTurnstileRef = useRef<TurnstileWidgetHandle>(null);



    // example password (replace with API value)
    const password = selectedCustomer?.password || "********";

    const forgetPassword = async () => {
        let obj: any = {
            email: selectedCustomer.email
        }

        try {
            setLoading(true);
            const response: any = await postData(ApiUrl.fogetPssword, obj);
            console.log('response', response)
            if (response?.isError) {
                showErrorToast(response.error.message)

                return;
            }

            sendLoginCredentialsMail(response.email, response.password, mailCaptchaToken);
            mailTurnstileRef.current?.reset();
            setSelectedCustomer((prev: any) => ({ ...prev, password: response.password }))
            showSuccessToast("Password forget email sent!")
            setLoading(false);

        } catch (error: any) {

            showErrorToast(error.response.data.message)
        }
    }



    function getCompletedVideos(videos: VideoItem[]) {

        return videos
            .filter(v => v.progress && v.progress.progressPercent > 0)
            .map(v => ({
                title: v.title,
                progress: v.progress!.progressPercent,
                language: v.language,
                videoUrl: v?.videoUrl
            }));
    }


    const getCourseProgress = async () => {

        if (!selectedCustomer?._id) return
        const response = await getData(ApiUrl.getVideosForViewers + selectedCustomer._id);
        const tutorialsLogs = getCompletedVideos(response);
        setTutorialLogs(tutorialsLogs);

    }

    const sendPasswordCreds = async () => {
        setEmailLoading(true)
        await sendAccountStatusChangeMail(selectedCustomer.email, selectedCustomer.first_name, "CONFIRMED", selectedCustomer.password, mailCaptchaToken)
        mailTurnstileRef.current?.reset();
        showSuccessToast("Login Creds sent successfully!")
        setEmailLoading(false)
    }

    useEffect(() => {
        getCourseProgress();
    }, [])

    return (
        <div className="flex flex-col h-[calc(80.5vh-200px)] 2xl:h-[calc(84vh-200px)] 4xl:h-[calc(90vh-200px)]">

            <div className={`p-3 m-3 rounded-[10px] flex-1 ${!hideLabels ? "border border-[#EEEEEE]" : ""}  bg-white pb-6 overflow-y-auto custom-scroll`}>
                {!hideLabels &&
                    <div className="text-[15px] font-medium text-gray-900  border-b-[1px] border-b-[#EEEEEE] pb-1">
                        Password
                    </div>
                }

                <div className="bg-white my-4 rounded-md">



                    <div className="sm:grid sm:grid-cols-2 lg:flex lg:items-center  gap-3">
                        {/* Password field */}
                        <input
                            type={showPassword ? "text" : "password"}
                            value={password}
                            readOnly
                            className={`w-[10rem] text-[13px] h-[32px] border-gray-400 animate-fadeIn !p-1 border rounded-[5px] bg-gray-50 text-[#323232] font-normal hover:border-gray-600 focus:outline-none focus:ring-[1.5px] focus:ring-greenBg focus:border-transparent`}
                        />

                        {/* Show / Hide button */}
                        <button
                            type="button"
                            onClick={() => setShowPassword(!showPassword)}
                            className="sm:w-[2.3rem]  p-2 border rounded-md hover:bg-gray-100"
                            title={showPassword ? "Hide Password" : "Show Password"}
                        >
                            {showPassword ? (
                                <EyeOff size={18} />
                            ) : (
                                <Eye size={18} />
                            )}
                        </button>

                        {/* Forgot password */}
                        <div className="flex justify-end mt-2 ">
                            <div className="
      p-[3.5px] 
      rounded-full 
      bg-gradient-to-r 
      hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
  hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
        hover:text-white
      shadow-[0.2px_4px_2px_#D2D2D2]
  ">
                                <button
                                    className="
        px-5 py-1 text-sm
        rounded-full
        bg-white
        text-[#7158E2]
        font-semibold
        transition-all duration-200
      hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
  hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
        hover:text-white
      "
                                    onClick={forgetPassword}
                                    disabled={isLoading}
                                >
                                    {isLoading ? "Sending Mail..." : "Forgot Password"}
                                </button></div></div>
                        <div className="flex justify-end mt-2 ">
                            <div className="
      p-[3.5px] 
      rounded-full 
      bg-gradient-to-r 
      hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
        hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
              hover:text-white
      shadow-[0.2px_4px_2px_#D2D2D2]
  ">
                                <button
                                    className="
        px-5 py-1 text-sm
        rounded-full
        bg-white
        text-[#7158E2]
        font-semibold
        transition-all duration-200 hover:bg-gradient-to-r from-[#CD84F1] via-[#c1bbf5] to-[#7158E2] 
          hover:bg-[length:200%_200%] hover:animate-[gradient-x_4s_ease_infinite]
                hover:text-white
        
      "
                                    onClick={sendPasswordCreds}
                                    disabled={emailLoading}
                                >
                                    {emailLoading ? "Sending Mail..." : "Email Login Creds"}
                                </button></div></div>

                        <div className="mt-2">
                            <TurnstileWidget
                                ref={mailTurnstileRef}
                                action="send_email"
                                onToken={setMailCaptchaToken}
                                appearance="interaction-only"
                            />
                        </div>

                    </div>
                </div>
                {!hideLabels &&
                    <div className="bg-white  my-3 rounded-md min-h-[14rem]">
                        <label className="block text-sm font-medium mb-2">
                            Logs
                        </label>

                        <div className="relative pl-4">
                            {/* vertical line */}
                            {(tutorialLogs.length === 0 && !selectedCustomer.lastLogoutTime) ? <div>
                                <b>No Log Found!</b>
                            </div> :
                                <div className="absolute left-[22px] top-0 w-[2px] h-full bg-gray-300"></div>}

                            <div className="space-y-6">
                                {selectedCustomer.lastLogoutTime &&
                                    <>
                                        <div className="relative flex items-start gap-3">
                                            {/* login */}
                                            <div className="absolute -left-0.5">
                                                <Circle size={10} className="text-gray-400 fill-gray-400" />
                                            </div>


                                            <div className="flex flex-col leading-tight ml-4">
                                                <span className="text-sm font-medium text-gray-800">Last Login</span>

                                                {/* <span className="text-sm text-[#4faaa1] cursor-pointer hover:underline">dd</span> */}

                                            </div>


                                            <div className="ml-auto text-sm text-gray-500 whitespace-nowrap">{formatDateInUS(selectedCustomer.lastLoginTime)}</div>

                                        </div>
                                        <div className="relative flex items-start gap-3">
                                            {/* login */}
                                            <div className="absolute -left-0.5">
                                                <Circle size={10} className="text-gray-400 fill-gray-400" />
                                            </div>


                                            <div className="flex flex-col leading-tight ml-4">
                                                <span className="text-sm font-medium text-gray-800">Last Logout</span>

                                                {/* <span className="text-sm text-[#4faaa1] cursor-pointer hover:underline">dd</span> */}

                                            </div>


                                            <div className="ml-auto text-sm text-gray-500 whitespace-nowrap">{formatDateInUS(selectedCustomer.lastLogoutTime)}</div>

                                        </div></>}
                                {tutorialLogs.map((item, i) => (
                                    <div key={i} className="relative flex items-start gap-3">
                                        {/* dot */}
                                        <div className="absolute -left-0.5">
                                            <Circle size={10} className="text-gray-400 fill-gray-400" />
                                        </div>


                                        <div className="flex flex-col leading-tight ml-4">
                                            <a target='_blank' href={item.videoUrl}>

                                                <span className="text-sm font-medium text-gray-800 hover:underline">Visited {item.title} </span>
                                                <br />
                                                {item.language && (
                                                    <span className="text-sm text-greenBg cursor-pointer capitalize hover:underline"> {item.language}</span>
                                                )}
                                            </a>
                                        </div>


                                        <div className="ml-auto text-sm text-gray-500 whitespace-nowrap">{item.progress}%</div>
                                    </div>
                                ))}


                            </div>
                        </div>


                    </div>}
            </div>
        </div>
    );
}
